export default {
  namespaced: true,
  state: {
    defaultDirId: '0'
  },
  mutations: {
    updateDirId (state, newDirId) {
      state.defaultDirId = newDirId
    }
  },
  actions: {
    updateDirId (context, newDirId) {
      context.commit('updateDirId', newDirId)
    }
  }
}
